/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  const $button = $('[data-embed-button]')

  $button.on('click', function(event) {
    const $this = $(this)
    const $container = $this.parent('[data-embed-container]')
    const url = $this.data('embed-button')
    const content =
      '<iframe src="' +
      url +
      '" width="1280" height="720" frameborder="0" allowtransparency="true" scrolling="no" allowfullscreen></iframe>'

    $container.empty()
    $container.html(content)

    event.preventDefault()
  })
}
